// SummaryStats — tira de totales separada por " · " ("Stock total: 20 unidades · 5 modelos · 7
// variantes activas" de B02; "Disponibles: 23 · Asignadas: 47 · Canceladas: 1" de B10). Cada stat
// es label + value; el value se resalta. Solo lectura.
import { Fragment, type ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface SummaryStat {
    label: string;
    value: ReactNode;
}

export interface SummaryStatsProps {
    stats: SummaryStat[];
    className?: string;
}

export function SummaryStats({ stats, className }: SummaryStatsProps) {
    if (stats.length === 0) return null;
    return (
        <div
            className={cn(
                'flex flex-wrap items-center text-[12px] text-muted-foreground',
                className,
            )}
        >
            {stats.map((s, i) => (
                <Fragment key={s.label}>
                    {i > 0 ? <span className="px-1.5 opacity-50">·</span> : null}
                    <span>
                        {s.label}: <span className="font-semibold text-foreground">{s.value}</span>
                    </span>
                </Fragment>
            ))}
        </div>
    );
}
